export var UserType;
(function (UserType) {
    UserType["Client"] = "client";
    UserType["Influencer"] = "influencer";
    UserType["Reseller"] = "reseller";
    UserType["StoreManager"] = "store_manager";
    UserType["DistributorManager"] = "distributor_manager";
    UserType["Cognito"] = "cognito";
    UserType["NetworkDistributor"] = "network_distributor";
    UserType["Affiliate"] = "affiliate";
    UserType["AffiliateManager"] = "affiliate_manager";
})(UserType || (UserType = {}));
